import React, { Component } from 'react'
import {
  Player,
  ControlBar,
  BigPlayButton,
  ReplayControl,
  PlayToggle,
  ForwardControl,
  VolumeMenuButton
} from 'video-react'
import '../../../node_modules/video-react/dist/video-react.css'
import { CloseButton, PlayerContainer } from './styled'
import { CLOSE_VIDEO } from './constants'
import client from '../../apollo'
import { SET_AGENT_STATE } from '../../apollo/actions'
import { Constants } from '@sukiai/components'

const { AGENT } = Constants

const styles = {
  veil: {
    position: 'fixed',
    height: '100vh',
    width: '100vw',
    backgroundColor: 'black',
    opacity: 0.9,
    zIndex: 10000
  }
}
// Video Player currently used for playing the OOBE videos at different places in the application
class VideoPlayer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isCloseButtonHovered: false
    }
    this.firstTimePlayClicked = true
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.isPlayerVisible !== this.props.isPlayerVisible) {
      this.handlePlayerVisibility(nextProps.isPlayerVisible)
    }
  }

  // Control the show/hide of the player
  handlePlayerVisibility = isPlayerVisible => {
    if (this.props.auxCallback) {
      this.props.auxCallback(isPlayerVisible)
    }
    if (isPlayerVisible) {
      if (!this.firstTimePlayClicked) {
        this.load()
      }
      this.play()
    } else {
      this.props.onPlayerClose()
      this.pause()
    }

    // mute agent to avoid unexpected tigger during video
    const newAgentState = isPlayerVisible ? AGENT.STATE.MUTED : AGENT.STATE.READY
    client.mutate({
      mutation: SET_AGENT_STATE,
      variables: { agentState: newAgentState }
    })
  }

  play = () => {
    this.refs.player.play()
  }

  pause = () => {
    this.refs.player.pause()
  }

  load = () => {
    this.refs.player.load()
  }

  render () {
    const { isCloseButtonHovered } = this.state
    const { isPlayerVisible, videoURL, handleClosedButton } = this.props
    return (
      <div>
        {this.props.isPlayerVisible && <div data-cy='oobe-player-veil' style={styles.veil} />}
        <PlayerContainer data-cy='oobe-video-player-container' shouldvideoplayershowandplay={isPlayerVisible ? 'true' : 'false'}>
          <Player ref='player'>
            <source src={videoURL} />
            <BigPlayButton position='center' />
            <ControlBar autoHide={false}>
              <PlayToggle />
              <ReplayControl seconds={10} order={2.2} />
              <ForwardControl seconds={10} order={3.2} />
              <VolumeMenuButton vertical />
            </ControlBar>
          </Player>
          <CloseButton
            onClick={() => {
              this.handlePlayerVisibility(false)
              this.firstTimePlayClicked = false
              handleClosedButton()
            }}
            onMouseEnter={() => { this.setState({ isCloseButtonHovered: true }) }}
            onMouseLeave={() => { this.setState({ isCloseButtonHovered: false }) }}
            isclosebuttonhovered={isCloseButtonHovered ? 'true' : 'false'}
            data-cy='oobe-video-screen-close-button'
          >
            {CLOSE_VIDEO}
          </CloseButton>
        </PlayerContainer>
      </div>
    )
  }
}

export default VideoPlayer
